/** Single source for canonical host + auth path checks (SSR, browser, sitemap). */
const siteHost =
  process.env.GATSBY_BRANDING === "stellantis"
    ? "stellantis.thgquoten.com"
    : process.env.GATSBY_BRANDING === "electrizone"
    ? "electrizone.thgquoten.com"
    : "www.thgquoten.com";

function pathKey(pathname) {
  const path = pathname || "/";
  return path === "/" ? path : path.replace(/\/$/, "");
}

function isAuthFlowPath(pathname) {
  const p = pathKey(pathname);
  if (
    p === "/login" ||
    p === "/register" ||
    p === "/forgot-password" ||
    p === "/reset-password" ||
    p === "/authenticated"
  ) {
    return true;
  }
  return p.startsWith("/authenticated/");
}

function isLegalPagePath(pathname) {
  const p = pathKey(pathname);
  return (
    p === "/agb" ||
    p === "/impressum" ||
    p === "/datenschutz" ||
    p === "/widerrufsbelehrung"
  );
}

function canonicalHrefForPath(pathname) {
  const path = pathname || "/";
  const withTrailingSlash =
    path === "/" ? "/" : path.endsWith("/") ? path : `${path}/`;
  return `https://${siteHost}${withTrailingSlash}`;
}

module.exports = {
  CANONICAL_ORIGIN: `https://${siteHost}`,
  canonicalHrefForPath,
  isAuthFlowPath,
  isLegalPagePath,
  isAuthSitemapPath: isAuthFlowPath,
};
